<template>
  <Vueform
    :key="startDate"
    class="w-full"
    :float-placeholders="false"
    :display-errors="false"
    :force-labels="false"
    :display-messages="false"
    v-model="dateData"
  >
    <div class="col-span-12">
      <DateElement
        name="startDate"
        label="Start Date"
        :placeholder="startDatePlaceholderText"
        :default="startDate"
        :min="getTodayDate()"
        display-format="DD-MM-YYYY"
        :rules="['required']"
        :messages="{
          required: 'Required',
        }"
        :add-classes="{
          DateElement: {
            inputContainer:
              '!border-[#C3C2C1] !rounded-[8px] !bg-[#FFFFFF] mt-[8px] md:mt-[12px] lg:mt-[16px]',
          },
          ElementLabel: {
            container:
              'text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.125rem] font-semibold text-[#191817]',
          },
        }"
      />
    </div>
  </Vueform>
</template>
<script>
export default {
  data() {
    return {
      dateData: {
        startDate: null,
      },
    };
  },
  props: {
    startDate: {
      type: String,
      default: null,
    },
    startDatePlaceholderText: {
      type: String,
      default: '',
    },
  },
  watch: {
    startDate: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.dateData.startDate = newVal;
        }
      },
    },
    'dateData.startDate'(newVal) {
      if (newVal) {
        let dateToEmit = newVal;
        if (dateToEmit.includes('T')) {
          dateToEmit = dateToEmit.split('T')[0];
        }
        this.$emit('handle-date-data', dateToEmit);
      }
    },
  },
  methods: {
    getTodayDate() {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const year = tomorrow.getFullYear();
      const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
      const day = String(tomorrow.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style scoped>
:deep(.form-input-group) {
  background-color: #ffffff !important;
  border: 1px solid #c3c2c1 !important;
  border-radius: 8px !important;
  min-height: unset !important;
}

:deep(.flatpickr-wrapper input) {
  height: auto !important;
  padding: 16px !important;
  color: #21201e;
  font-size: 16px;
  line-height: 24px;
}

@media (min-width: 768px) {
  :deep(.flatpickr-wrapper input) {
    font-size: 28px;
    line-height: 38px;
  }
}

@media (min-width: 1024px) {
  :deep(.flatpickr-wrapper input) {
    font-size: 30px;
    line-height: 40px;
  }
}
</style>
